<template>
    <div style="width:85%">
        <div class="detail-header">
            <el-button @click="returnList" size="mini">返回</el-button>
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-left: 20px">
                <el-breadcrumb-item><b class="linkTo" @click="$emit('returnClientList')">客户列表</b></el-breadcrumb-item>
                <el-breadcrumb-item v-if="tmpFromPage==='ClientDetail'"><b class="linkTo" @click="returnList">客户详情</b></el-breadcrumb-item>
                <el-breadcrumb-item v-if="tmpFromPage==='ContactList'"><b class="linkTo" @click="$emit('returnClientDetail')">客户详情</b></el-breadcrumb-item>
                <el-breadcrumb-item v-if="tmpFromPage==='ContactList'"><b class="linkTo" @click="returnList">联系人列表</b></el-breadcrumb-item>
                <el-breadcrumb-item>联系人详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div>
            <div class="contact-name">{{tmpContactName}}</div>
            <ContactDetailCard :clientId="clientId" :contactId="contactId" :clientName="clientName" @refresh="refresh" />
            <ContactPreference :contactId="contactId" :contactName="tmpContactName" />
        </div>
        
    </div>
</template>

<script>
import ContactDetailCard from "@/component/Client/Contact/ContactDetail/ContactDetailCard"
import ControlPanel from "@/component/Client/ClientDetail/ControlPanel/ControlPanel";
import ContactPreference from "@/component/Client/Contact/ContactPreference/ContactPreference"
export default {
    name: "ContactDetail",
    components: {
        ContactDetailCard,
        ControlPanel,
        ContactPreference
    },
    props: {
        clientId: {
            required: true
        },
        contactId: {
            required: true
        },
        contactName: {
            required: true
        },
        clientName: {
            required: true
        },
        fromPage: {
            required: true
        }
    },
    data() {
        return {
            tmpContactName: this.contactName,
            tmpFromPage: this.fromPage
        }
    },
    methods: {
        returnList() {
            this.$emit('returnList')
        },
        refresh(refreshContactName=false) {
            this.$emit('refresh', true)
            if(refreshContactName){
                this.tmpContactName = refreshContactName
            }
            
        }
    }
}
</script>

<style scoped>

.content {
    width: 85%;
}
.detail-header{
    display: flex;
    align-items: center;
}
.contact-name{
    width: 100%;
    box-shadow:0 0px 12px 0 rgb(0 0 0 / 10%);
    border-radius: 5px;
    padding: 30px;
    margin-top: 10px;
    font-weight: bold;
    font-size:18px;
    /* min-width: 1754px; */
}
.contact-main {
    width: 100%;
}

.linkTo{
  cursor: pointer;
}
.linkTo:hover{
  color:#1473E3;
}

</style>
